<template>
  <div >
    <span class="fa fa-chevron-left fa-2x arrow-left"
          @click="left"
          v-bind:style="{top: topStyle, left: leftStyle }"
      ></span>
    <span class="fa fa-chevron-right fa-2x arrow-right"
          @click="right"
          v-bind:style="{top: topStyle }"
    ></span>
  </div>

</template>
<script>
  export default{
    props: {
      body: {
        type: String,
        default: ''
      },
      topStyle: {
        default: '40px',
        type: String
      },
      leftStyle: {
        default: '260px',
        type: String
      }
    },
    methods: {
      right() {
        document.getElementById(this.body).scrollLeft += 60
      },
      left() {
        document.getElementById(this.body).scrollLeft -= 60
      }
    }
  }
</script>
<style>
  .arrow-left{
    position: relative;
    z-index: 10;
    cursor: pointer;
    color: #ccc;
  }

  .arrow-right{
    position: relative;
    z-index: 10;
    float: right;
    cursor: pointer;
    color: #ccc;

  }
</style>
